import styled from 'styled-components';

export const MidiaKitContainer = styled.section`
  display: flex;
  flex-direction: column;
  margin: 50px auto;
  width: 100%;
  min-height: 50vh;
`;

export const MidiaKitHeader = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
  width: 100%;
`;

export const MidiaKitTitle = styled.h1`
  color: #272727;
  font-size: 23px;
  font-weight: 700;
`;

export const InputLabel = styled.label`
  padding: 10px 30px;
  font-size: 16px;
  text-align: center;
  text-transform: uppercase;
  font-weight: 700;
  color: #fff;
  border-radius: 18px;
  background: #ffcb29;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.15);
  cursor: pointer;

  &:hover {
    background-color: #020c90;
  }
`;

export const Input = styled.input`
  padding: 10px;
  border-radius: 18px;
  border: 1px solid #9a9a9a;

  &:disabled {
    border: none;
    background-color: #f9f9f9;
    color: #272727;
  }

  &:autofill,
  &:autofill:hover,
  &:autofill:focus,
  &:autofill:active {
    transition: background-color 0s 600000s, color 0s 600000s;
    color: #272727;
  }
`;

export const MidiaKitLink = styled.a`
  color: #272727;
  font-size: 16px;
  font-weight: 500;
  text-decoration: underline;
`;

export const MidiaKitActionButtons = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: auto;
`;

export const MidiaKitCancelButton = styled.button`
  margin-right: 20px;
  font-size: 16px;
  text-align: center;
  text-transform: uppercase;
  font-weight: 700;
  color: #ffcb29;
  padding: 10px 20px;
  border: 1px solid #ffcb29;
  border-radius: 18px;
  background: #fff;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.15);
  cursor: pointer;

  &:hover {
    background-color: #020c90;
    color: #fff;
    border: 1px solid #020c90;
  }
`;

export const MidiaKitSaveButton = styled.button`
  text-align: center;
  font-size: 16px;
  text-transform: uppercase;
  font-weight: 700;
  color: #fff;
  padding: 10px 30px;
  border: none;
  border-radius: 18px;
  background: #ffcb29;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.15);
  cursor: pointer;

  &:hover {
    background-color: #020c90;
  }

  &:disabled {
    background-color: #ccc;
    color: #f9f9f9;
    cursor: not-allowed;
  }
`;
